export default __webpack_public_path__ + "static/media/greenTickIcon.225770ec.png";